import { LazyFooter } from "src/website-apps/shared/components/footer";

/**
 * Footer Section of Find Layout
 */
export const FindLayoutFooter = ({ model }) => {
  const { footer } = model;

  return (
    <LazyFooter
      companyLinks={footer?.companyLinks}
      getLocationSettingsUrl={footer?.getLocationSettingsUrl}
      supportLinks={footer?.supportLinks}
    />
  );
};
